import ResourceHeading from './ResourceHeading';

export default ResourceHeading;
